/**
 * Enum of tab names used in Scheduler.
 */
export enum SchedulerTab {
  Appointments = 'appointments',
  ManageSlots = 'manageSlots',
  SchedulerSettings = 'schedulerSettings'
}
